import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import {
  GET_ADDRESS_BOOK,
  GetAddressBookAction,
  GetAddressBookFailureAction,
  GetAddressBookSuccessAction,
  SET_ADDRESS_BOOK_PARAMS,
  SetAddressBookParamsAction
} from './address-book.actions';
import { AddressBookService } from './address-book.service';
import { AddressBookSearchParams } from './address-book-params.interface';
import { AddressBookResponse } from './model/address-book.model';
import { PaginatedData } from '../shared/models/table';

@Injectable()
export class AddressBookEffects {
  @Effect()
  getContacts$: Observable<any> = this.actions$.pipe(
    ofType(GET_ADDRESS_BOOK),
    map((action: GetAddressBookAction) => action.payload),
    switchMap((payload: AddressBookSearchParams) => {
      const request = this.normalizeRequestToMatchBackendStructure(payload);
      return this.addressBookService.getContacts(request).pipe(
        switchMap((response: PaginatedData<AddressBookResponse>) => {
          return [new GetAddressBookSuccessAction(response)];
        }),
        catchError(error => of(new GetAddressBookFailureAction(error)))
      );
    })
  );

  @Effect()
  setAddressBookParams$: Observable<any> = this.actions$.pipe(
    ofType(SET_ADDRESS_BOOK_PARAMS),
    map((action: SetAddressBookParamsAction) => action.payload),
    map((payload: AddressBookSearchParams) => new GetAddressBookAction(payload))
  );

  private normalizeRequestToMatchBackendStructure(payload: AddressBookSearchParams): AddressBookSearchParams {
    // backend's paginator starts from 1, but mat-paginator requires starting from 0,
    // so we need to increase current page number
    return { ...payload, pager: { ...payload.pager, page: payload.pager.page + 1 } };
  }

  constructor(private actions$: Actions, private addressBookService: AddressBookService) {}
}
